import React from 'react'
import { shape, bool, func, string } from 'prop-types'
import moment from 'moment'
import { ENABLE_ACCOMMODATIONS } from '../../configuration/constants'

import DefaultCrossingCard from './DefaultCrossingCard/DefaultCrossingCard'
import ShipNameCrossingCard from './ShipNameCrossingCard/ShipNameCrossingCard'

const CrossingCardContainer = ({
  crossing,
  selectCrossing,
  isDisabled,
  isCurrentlySelectedRoute,
  activeVehicleResourceCode,
  passengerAvailability,
  activeVehicle
}) => {
  const { departureDate } = crossing
  let accommodationsAvailable = false
  let vehiclesAvailable
  let isOverNight
  let isDisabledParam = isDisabled
  let petExteriorAvailable = false

  const { formattedResources, departureTime } = crossing
  const crossingVehicles = formattedResources?.vehicles || []

  const filteredVehicles = activeVehicleResourceCode
    ? crossingVehicles.filter(
        vehicle => vehicle.resourceCode === activeVehicleResourceCode
      )
    : crossingVehicles

  vehiclesAvailable = filteredVehicles.some(vehicle => {
    return activeVehicle?.vehicleLength
      ? +vehicle.freeCapacity >= +activeVehicle?.vehicleLength
      : vehicle.freeCapacity > 0
  })

  let crossingAccommodations = []
  if (ENABLE_ACCOMMODATIONS) {
    crossingAccommodations = formattedResources?.accommodations || []
    accommodationsAvailable = crossingAccommodations.some(
      accommodation => +accommodation.freeCapacity > 0
    )
    petExteriorAvailable = crossingAccommodations.some(
      accommodation =>
        accommodation.resourceCode === 'PTE' && +accommodation.freeCapacity > 0
    )
  }

  const departureTimeNumber = +moment(departureTime, 'HH:mm').format('HHmm')
  isOverNight = departureTimeNumber > 0 && departureTimeNumber < 400

  if (process.env.REACT_APP_CROSSING_CARD_LAYOUT === 'ship_name') {
    return (
      <ShipNameCrossingCard
        accommodationsAvailable={accommodationsAvailable}
        petExteriorAvailable={petExteriorAvailable}
        crossing={crossing}
        departureDate={departureDate}
        isCurrentlySelectedRoute={isCurrentlySelectedRoute}
        isDisabled={isDisabledParam}
        isOverNight={isOverNight}
        selectCrossing={selectCrossing}
        vehiclesAvailable={vehiclesAvailable}
      />
    )
  }

  return (
    <DefaultCrossingCard
      accommodationsAvailable={accommodationsAvailable}
      petExteriorAvailable={petExteriorAvailable}
      crossing={crossing}
      departureDate={departureDate}
      isCurrentlySelectedRoute={isCurrentlySelectedRoute}
      isDisabled={isDisabledParam}
      isOverNight={isOverNight}
      passengerAvailability={passengerAvailability}
      selectCrossing={selectCrossing}
      vehiclesAvailable={vehiclesAvailable}
      activeVehicleResourceCode={activeVehicleResourceCode}
    />
  )
}

CrossingCardContainer.propTypes = {
  crossing: shape().isRequired,
  selectCrossing: func.isRequired,
  isDisabled: bool,
  isCurrentlySelectedRoute: bool,
  activeVehicleResourceCode: string,
  activeVehicle: shape(),
  passengerAvailability: bool
}

export default CrossingCardContainer
